<template>
  <div>
    <div>
      <div :id="id" :style="{ height: height, width: width }"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object
    },
    name: {
      type: String
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const OPTIONS = this.option
      this.chart.setOption({
        color: [
          '#007EFF',
          '#1EE4DC',
          '#FFD71C',
          '#FF6246',
          '#83CF46',
          '#7159FF',
          '#FFFFFF',
          '#A352FF',
          '#3ED5FF',
          '#F07028'
        ],
        title: {
          text: this.name,
          x: 'left',
          left: '2%',
          textStyle: {
            fontSize: 14,
            color: '#fff',
            lineHeight: 40
          }
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          textStyle: {
            color: '#ffffff'
          }
        },
        series: {
          bottom: '10%',
          top: '15%',
          right: '16%',
          left: '3%',
          type: 'sankey',
          layout: 'none',
          nodeGap: 50,
          focusNodeAdjacency: 'allEdges',
          data: OPTIONS.data,
          links: OPTIONS.links,
          label: {
            normal: {
              color: '#fff',
              // fontSize: 20,
              formatter: params => {
                const rateValue =
                  params.dataIndex === 0
                    ? ''
                    : OPTIONS.links[params.dataIndex - 1]
                      ? OPTIONS.links[params.dataIndex - 1].value + '%'
                      : 0
                return (
                  '{title|' +
                  params.data.name +
                  '\n}' +
                  '{value| ' +
                  params.data.value +
                  '\n}' +
                  '{rate| ' +
                  rateValue +
                  ' }'
                )
              },
              rich: {
                title: {
                  fontSize: 12,
                  padding: [10, 0, 0, 0]
                },
                value: {
                  // color: 'rgba(255,255,255,0.6)',
                  fontSize: 12
                },
                rate: {
                  // color: 'rgba(255,255,255,0.6)',
                  fontSize: 12
                }
              }
            }
          }
        }
      })
      this.chart.on('click', params => {
        const clickObj = params
        if (clickObj.dataType === 'node') {
          this.$emit('sankey-click', clickObj)
        }
      })
    }
  },
  created () {}
}
</script>
